import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetData } from "../../features/login/LoginSlice";
import {
  FaTachometerAlt,
  FaBuilding,
  FaHome,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaUniversity,
  FaBox,
  FaStar,
  FaScroll,
  FaTools,
  FaLandmark,
  FaFolder,
  FaUserShield,
  FaTags,
  FaUsers,
  FaChartLine,
  FaChartBar,
} from "react-icons/fa";
import { GiGiftOfKnowledge } from "react-icons/gi";
import { FaDatabase } from "react-icons/fa6";

export const useNavbar = () => {
  const { modules } = useSelector((state) => state.loginSlice);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [openAlert, setOpenAlert] = useState(false);

  const mapNavigationWithIcons = (navigationItems) => {
    const getIcon = (name) => {
      switch (name) {
        case "Dashboard":
          return <FaTachometerAlt />;
        case "Merchant Management":
          return <FaBuilding />;
        case "Merchants":
          return <FaHome />;
        case "Uninstalled Merchants":
          return <FaHome />;
        case "Billing & Finance":
          return <FaMoneyBillWave />;
        case "Currency":
          return <FaMoneyBillWave />;
        case "Billing Cycle":
          return <FaCalendarAlt />;
        case "Tax":
          return <FaUniversity />;
        case "Subscription & Features":
          return <FaBox />;
        case "Masters":
          return <FaDatabase />;
        case "Features":
          return <FaStar />;
        case "Plan":
          return <FaScroll />;
        case "System Management":
          return <FaTools />;
        case "Knowledge Center":
          return <GiGiftOfKnowledge />;
        case "Application":
          return <FaLandmark />;
        case "Module":
          return <FaFolder />;
        case "Access Control":
          return <FaUserShield />;
        case "Role":
          return <FaTags />;
        case "Users":
          return <FaUsers />;
        case "Reports & Analytics":
          return <FaChartLine />;
        case "Reports":
          return <FaChartBar />;
        default:
          return null; // Default icon
      }
    };
    const mapWithIcons = (items) => {
      return items?.map((item) => ({
        ...item,
        icon: getIcon(item.title),
        subItems: item.subItems ? mapWithIcons(item.subItems) : null,
      }));
    };

    return mapWithIcons(navigationItems);
  };

  const [tabs, setTabs] = useState(mapNavigationWithIcons(modules));

  useEffect(() => {
    setTabs(mapNavigationWithIcons(modules));
  }, [modules]);

  const catalogIndex = modules?.findIndex(
    (item) => item.sModuleName === "Catalog"
  );
  const [openIndex, setOpenIndex] = useState(catalogIndex);

  const handleItemClick = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  const handleLogout = () => {
    setOpenAlert(false);
    dispatch(resetData());
    navigate("/", { replace: true });
  };

  const handleClose = () => {
    setOpenAlert(false);
  };
  const handleOpen = () => {
    setOpenAlert(true);
  };

  return {
    openAlert,
    handleClose,
    handleLogout,
    handleOpen,
    modules,
    handleItemClick,
    openIndex,
    setOpenIndex,
    tabs,
  };
};
